import React from "react";
import { UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { ManageMultipleFilesModal } from "./ManageMultipleFilesModal";

interface Props {
  flightPassengerId: number
  isOpen: boolean
  onClose: () => void
  canEdit: boolean

  files: server.dto.File[]
  onFilesChanged: () => Promise<void>
}

export const ManageFlightPassengerFilesModal = (props: Props) => {
  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.FlightPassenger.UploadPassengerFiles,
      window.CoreApi.FlightPassenger.UploadPassengerFiles.absoluteUrl(),
      {
        files,
        flightPassengerId: props.flightPassengerId
      },
      uploadConfig
    );
  };

  // After removing the last file, the parent might be removed from the DOM
  // In in-page editing scenarios, we need to ensure we call the cancel function
  React.useEffect(() => {
    return () => props.onClose();
  }, []);

  return <ManageMultipleFilesModal
    {...props}
    upload={uploadFiles}
    deleteEndpoint={(id: number) => window.CoreApi.FlightPassenger.DeletePassengerFile({
      flightPassengerFileId: id
    })}
    renameEndpoint={(file: server.dto.File) => window.CoreApi.FlightPassenger.UpdatePassengerFileName({
      flightPassengerFileId: file.id,
      fileName: file.name
    })}
  />
}